import { render, staticRenderFns } from "./appsManagement.vue?vue&type=template&id=503f5bb1&"
import script from "./appsManagement.vue?vue&type=script&lang=js&"
export * from "./appsManagement.vue?vue&type=script&lang=js&"
import style0 from "./appsManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports